import { Injectable } from '@angular/core'
import { BaseService } from '@appService/base.service'
import { Observable } from 'rxjs'
import { ResponseModel } from '../api-response.model'

@Injectable({
  providedIn: 'root'
})
export class SystemParamatersService extends BaseService {
  contextPath = '/api/system-parameters'


  apiSearch(payload: any): Observable<ResponseModel<any[]>> {
    return this.get(`${this.contextPath}`, payload)
  }

  createSys(payload: any): Observable<ResponseModel<any[]>> {
    return this.post(`${this.contextPath}`, payload)
  }

  updateSys(payload: any, id: any): Observable<ResponseModel<any[]>> {
    return this.put(`${this.contextPath}/${id}`, payload)
  }

  deleteSys(id: any): Observable<ResponseModel<any[]>> {
    return this.delete(`${this.contextPath}/${id}`)
  }

  detail(id: any): Observable<ResponseModel<any[]>> {
    return this.get(`${this.contextPath}/${id}`)
  }

  getPublic(): Observable<any> {
    return this.get(`${this.contextPath}`)
  }
}
